import React from 'react';
import { Typography } from '@mui/material';

const Display404 = () => (
  <Typography variant="h6">
    Sorry, the page you're looking for cannot be found!
  </Typography>
);

export default Display404;
